module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-BoldItalic-c2872996da0bd4638cf02fbfddb8b50e.ttf";